export default __webpack_public_path__ + "static/media/drinks-8.36ddee25.png";